import React from "react";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Button, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import {APP_SECTION, PARTY, APPOINTMENT, createObjectForKeys, ID_FINISH, PAGES} from "../../../scripts/constants";
import Resources from "../../../Resources/Resources";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {isValid, mygaSession} from "../../../scripts/myga-session";
import {getTimeTextForHour24, getToken, loadTimeSlots, scheduleCall} from "../../../scripts/scheduler";
import {charLimits, NassauLog, regex} from "../../../scripts/myga-utils";
import {saveApplication, saveValidationReport, submitApp} from "../../../scripts/sync-manager";
import GENERATOR from "../../../selenium-front-end/generator/Generator";

class AppPartialComplete extends React.Component {

    constructor(props) {
        super(props);
        // setup default prev/next pages with props overrides
        // this.nextPage = props.nextPage || PAGES.pageDashboard; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
    
        let nextState = {
            errorMessage: '',
            timezone: '',
            requestedDate: '',
            requestedTime: '',
            days: [],
            slots: [],
            isBusy: false,
            edit: false,
            isScheduled: false,
            isScheduleError : false,
        };
    
        let owner = mygaSession.getCurrentAppOwner();
        NassauLog(`owner: ${JSON.stringify(owner)}`);
        nextState[PARTY.daytimePhone] = owner[PARTY.daytimePhone];
    
        // Load the component state from the current application
        this.state = nextState;
    
    }
    
    componentDidMount() {
        
        this.getTimeSlots();
        
        getToken()
            .then((token)=>{
                NassauLog(`dtcToken: ${token}`);
                this.dtcToken = token;
            })
            .catch((err)=> {
                NassauLog(err);
            });
    }
    
    getTimeSlots() {
        this.setState({
            isBusy: true
        },()=>{
            loadTimeSlots(this.state.requestedDate)
                .then((schedule)=>{
                    NassauLog(`schedule: ${JSON.stringify(schedule)}`);
                    let nextState = {
                        isBusy: false,
                        errorMessage: ''
                    };
                    if (isValid(schedule.days)) {
                        nextState.days = schedule.days;
                        nextState.requestedDate = schedule.days[0].id;
                    }
                    if (isValid(schedule.slots)) {
                        nextState.slots = schedule.slots;
                    }
                    if (isValid(schedule.timezone))  {
                        nextState.timezone = schedule.timezone;
                    }
                    this.setState(nextState)
                })
                .catch((err)=>{
                    NassauLog(err);
                    this.setState({
                        isBusy: false,
                        errorMessage: err.message,
                        requestedDate: '',
                        days: [],
                        slots: [],
                    })
                });
        })
    }
    
    // 2021.10.05.ADivelbiss - M
    scheduleCall = async () => {
        
        if (this.state.requestedDate==='') {
            this.setState({
                errorMessage:MYGAStrings.ScheduleCall_MissingDateError
            });
            return;
        }
        
        if (this.state.requestedTime==='') {
            this.setState({
                errorMessage:MYGAStrings.ScheduleCall_MissingTimeError
            });
            return;
        }
        
        this.setState({isBusy: true, isScheduleError: false});
        // 2021.10.05.ADivelbiss - udpaed to support submitting the application after
        // schedulding the call is successful.
        try {
            let data = await scheduleCall(this.dtcToken,this.state.requestedDate, this.state.requestedTime, this.state.timezone);
            NassauLog(`scheduleCall response: ${JSON.stringify(data,null,2)}`);
            // Save the appointment information.
            let appointment = createObjectForKeys(APPOINTMENT);
            appointment[APPOINTMENT.date] = this.state.requestedDate;
            appointment[APPOINTMENT.hour] = this.state.requestedTime;
            mygaSession.setCurrentAppSectionData(APP_SECTION.appointment,appointment);
            await saveApplication(APP_SECTION.appointment);
            // save the validation report now BEFORE submitApp
            await saveValidationReport();
            // if we got this far submit the application.
            await submitApp();
            this.setState({isBusy: false, isScheduled: true, errorMessage: ''});
        } catch (err) {
            NassauLog(err.message);
            this.setState({isBusy: false, isScheduleError: true, errorMessage: ''});
        }
        // 2021.10.05.ADivelbiss - orginal code
        // scheduleCall(this.dtcToken,this.state.requestedDate, this.state.requestedTime, this.state.timezone)
        //     .then((data)=>{
        //         NassauLog(`scheduleCall response: ${JSON.stringify(data,null,2)}`);
        //         //
        //         this.setState({isBusy: false, isScheduled: true, errorMessage: ''});
        //     })
        //     .catch((err)=>{
        //         NassauLog(err.message);
        //         this.setState({isBusy: false, isScheduleError: true, errorMessage: ''});
        //     })
    }
    
    
    getDateText() {
        let text = '';
        if (this.state.days.length>0 && this.state.requestedDate.length>0) {
            text = this.state.days.filter((item) => {
                return (item.id === this.state.requestedDate);
            })[0].text
        }
        return text;
    }
    
    renderSlots() {
        return (
            <>
                {
                    this.state.slots.length > 0 ? (
                        <div className={''}>
                            {
                                this.state.slots.map((item,index)=>{
                                    return (
                                        <Button id={`time${index}`} variant="primary" size="sm" key={index}
                                                onClick={()=>{ this.setState({requestedTime: item.start, errorMessage: ''})  }}
                                        >
                                            {getTimeTextForHour24(item.start)}
                                        </Button>
                                    )
                                })
                            }
                        </div>
                    ) : (
                        <div>
                            There are no times available for this day.
                        </div>
                    )
                }
            </>
        )
    }
    
    validate = () => {
        // 2021.07.16.ADivelbiss - onNext and onPrev Validation
        if (this.state.requestedDate==='') {
            this.setState({
                errorMessage:MYGAStrings.ScheduleCall_MissingDateError
            });
            return false;
        }
    
        if (this.state.requestedTime==='') {
            this.setState({
                errorMessage:MYGAStrings.ScheduleCall_MissingTimeError
            });
            return false;
        }
    
        if (this.state.isScheduled===false) {
            this.setState({
                errorMessage:MYGAStrings.ScheduleCall_NotScheduledError
            });
            return false;
        }
    
        return true;
    };
    
    onNextPressed = async () => {
      if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {

        let actionList = [
          {
            type: 'click',
            id: 'date1'
          },
          {
            type: 'click',
            id: 'time0'
          },
          {
            type: 'click',
            id: 'scheduleCallBtn'
          },
          {
            type: 'wait',
            id: 'scheduleSuccess',
            timeout: 15000
          }
        ]
        await GENERATOR.stageManualActionList(actionList)
  
        // stop the test at this point.
        await GENERATOR.disableAfterNextCommit();
      }
    };

    render() {

        return (

            <AppContentWrapper
                nextLabel={MYGAStrings.AppCompleted_ButtonForwardLabel}
                validateOnPrev={this.validate}
                validateOnNext={this.validate}
                onNextPressed={this.onNextPressed}
                updatePage={this.props.updatePage}
                errorMessage={this.state.errorMessage}>

                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <div className={"row"}>
                                <div className={"font-page-regular"}>
                                    Pick a day and an available time slot that works for you.
                                </div>
                            </div>
                            {
                                (this.state.requestedDate==='' && this.state.isBusy) ? (
                                        <Container className="page-answer-select pt-2">
                                            <Row className={'text-center'}>
                                                <Col>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="lg"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                </Col>
                                            </Row>
                                        </Container>
                                    ) : (this.state.requestedTime==='') ? (
                                        <Container className="scheduler pt-2">
                                            {/* Date Selector */}
                                            <Row className="page-answer-select">
                                                <Col xs={12} sm={2} className="text-left">
                                                    <div>Date: </div>
                                                </Col>
                                                <Col xs={12} sm={10} md={6} className="text-left">
                                                    <select className={"form-control page-select"}
                                                            required
                                                            value={this.state.requestedDate}
                                                            onChange={(event)=>{
                                                                this.setState({
                                                                    requestedDate: event.target.value
                                                                },()=>{
                                                                    this.getTimeSlots()
                                                                })
                                                            }}>
                                                        {
                                                            this.state.days.map((item, index)=>{
                                                                return <option id={`date${index}`} key={index} value={item.id}>{item.text}</option>
                                                            })
                                                        }
                                                    </select>
                                                </Col>
                                            </Row>
                    
                                            {/* Instructions */}
                                            <Row className={'pb-3'}>
                                                <Col className={'border-bottom'}>
                                                    <label>Select an available time for an appointment ({this.state.timezone})</label>
                                                </Col>
                                            </Row>
                    
                                            {/* Time slot selection buttons */}
                                            <Row className={'pb-3'}>
                                                <Col xs={12} sm={4} className={''}>
                                                    <div>{this.getDateText()}</div>
                                                </Col>
                                                {
                                                    this.state.isBusy ? (
                                                        <Col xs={12} sm={8} className={'text-center'}>
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="lg"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        </Col>
                                                    ) : (
                                                        <Col xs={12} sm={8} >
                                                            {
                                                                this.renderSlots()
                                                            }
                                                        </Col>
                                                    )
                                                }
                                            </Row>
                    
                                            {/* Phone number display and edit form */}
                                            <Row className={'pb-3'}>
                                                <Col xs={12} sm={4} className={''}>
                                                    <div>We will call you at: </div>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} >
                                                    {
                                                        this.state.edit ? (
                                                            <Form inline className={'auth-form needs-validation'}
                                                                  ref={(form) => {
                                                                      this.pageForm = form;
                                                                  }}>
                                                                <Form.Group>
                                                                    <Form.Control
                                                                        type="text" required
                                                                        className="page-input"
                                                                        name={PARTY.daytimePhone}
                                                                        value={this.state[`${PARTY.daytimePhone}_edit`]}
                                                                        onChange={(e)=>{
                                                                            let nextState = {};
                                                                            nextState[`${PARTY.daytimePhone}_edit`] = e.target.value;
                                                                            nextState.errorMessage = '';
                                                                            this.setState(nextState);
                                                                        }}
                                                                        placeholder="Daytime Phone Number"
                                                                        pattern={regex.phoneNumberUS}
                                                                        maxLength={charLimits.phoneNumberUS}
                                                                    />
                                                                    <Button variant="link" size="" onClick={()=>{
                                                                        if (!this.pageForm.checkValidity()) {
                                                                            this.pageForm.classList.add('was-validated');
                                                                            this.setState({
                                                                                errorMessage: MYGAStrings.ScheduleCall_PhoneNumberError
                                                                            })
                                                                        } else {
                                                                            let nextState = { edit: false};
                                                                            nextState[PARTY.daytimePhone] = this.state[`${PARTY.daytimePhone}_edit`];
                                                                            this.setState(nextState);
                                                                        }
                                                                    }}>
                                                                        <FontAwesomeIcon icon={Resources.Icons.Check}/>
                                                                    </Button>
                                                                    <Button variant="link" size="" onClick={()=>{
                                                                        this.setState({ edit: false })
                                                                    }}>
                                                                        <FontAwesomeIcon icon={Resources.Icons.TrashCan}/>
                                                                    </Button>
                                                                </Form.Group>
                                                            </Form>
                                                        ) : (
                                                            <>
                                                                {this.state[PARTY.daytimePhone]}
                                                                <Button variant="link" size="" onClick={()=>{
                                                                    let nextState = { edit: true};
                                                                    nextState[`${PARTY.daytimePhone}_edit`] = this.state[PARTY.daytimePhone];
                                                                    this.setState(nextState);
                                                                }}>
                                                                    <FontAwesomeIcon icon={Resources.Icons.Pencil}/>
                                                                </Button>
                                                            </>
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                
                                        </Container>
                                    ) : (
                                        <Container>
                    
                                            {/* Schedule summary */}
                                            <Row className={'border-bottom mt-5 pt-1'}>
                                                <Col className={'text-left'}>
                                                    We will call you at:
                                                </Col>
                                                <Col className={'text-left'}>
                                                    Date:
                                                </Col>
                                                <Col className={'text-left'}>
                                                    Time:
                                                </Col>
                                            </Row>
                                            <Row className={'pt-1'}>
                                                <Col className={'text-left'}>
                                                    {this.state[PARTY.daytimePhone]}
                                                </Col>
                                                <Col className={'text-left'}>
                                                    {this.getDateText()}
                                                </Col>
                                                <Col className={'text-left'}>
                                                    {getTimeTextForHour24(this.state.requestedTime)}
                                                    {
                                                        (this.state.isScheduled===false) && (
                                                            <Button variant="link" size="" onClick={()=>{
                                                                let nextState = { requestedTime: ''};
                                                                this.setState(nextState);
                                                            }}>
                                                                <FontAwesomeIcon icon={Resources.Icons.Pencil}/>
                                                            </Button>
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                    
                                            {/* Instructions */}
                                            {
                                            (this.state.isScheduled===false) ? (
                                                <Row className={'pt-5'}>
                                                    <Col className={'text-center'}>
                                                        {
                                                            (this.state.isScheduleError) && (
                                                                <p>We have encounter a problem making this appointment.  Please try again.</p>
                                                            )
                                                        }
                                                        <p>Review your appointment details and finalize by selecting the Schedule Call button.</p>
                                                        <Button id={'scheduleCallBtn'} variant="primary" size="" onClick={()=>{this.scheduleCall();}} disabled={this.state.isBusy}>
                                                            {
                                                                this.state.isBusy ? (
                                                                    <Spinner
                                                                        as="span"
                                                                        animation="border"
                                                                        size="lg"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : (
                                                                    <>Schedule Call</>
                                                                )
                                                            }
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row className={'pt-5'}>
                                                    <Col id={'scheduleSuccess'} className={'text-left'}>
                                                        The phone appointment is now confirmed. Thank you!
                                                    </Col>
                                                </Row>
                                            )
                                            }
                                        </Container>
                                    )
                            }
                        </div>
                    </div>
                </div>
                <Container className="">
                    <Row className="">
                        <Col className={'page-fine-print'}>
                            <hr />
                            <p><strong>Scheduling your call to complete the final steps of your application is very important. It may impact the rate we are able to offer you.</strong></p>
                            <p>Current rates will be locked in as of the application signed date or as of the contract issue date, whichever is better, if the application is in good order. You will not sign your application until after you speak with us.</p>
                            <p>If funds are not received within 60 days, the current credited interest rate effective on the contract issue date will apply.</p>
                        </Col>
                    </Row>
                </Container>

            </AppContentWrapper>

        );

    }
}

export default AppPartialComplete;